<template>
    <CompassSegmentedControl
        :modelValue="activeFilter[0]"
        :options="options"
        @update:modelValue="handleChange"
    />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { Translator } from 'types/injects/translator.type';

interface Option {
    value: string;
    label: string;
}

interface Props {
    activeFilter: string[];
    overviewType: string;
}

const props = defineProps<Props>();

const emit = defineEmits(['filterUpdate']);

const $t = inject('$t') as Translator;

const store = useStore();

const options = computed<Option[]>(() => {
    const list: Option[] = [{ value: 'all', label: $t.__('common.labels.all') }];

    if (props.overviewType === 'third') {
        list.push({
            value: 'third',
            label: store.getters.identity.isCorporation
                ? $t.__('common.labels.company')
                : $t.__('common.labels.individual'),
        });
    }

    list.push(
        { value: 'opportunity', label: $t.__('common.labels.opportunity') },
        { value: 'people', label: $t.__('common.labels.contact') },
        { value: 'estimate', label: $t.__('common.labels.estimate') },
        { value: 'invoice', label: $t.__('common.labels.invoice') },
    );

    return list;
});

const handleChange = (value: string): void => {
    if (value !== '') {
        emit('filterUpdate', [value]);
    }
};
</script>
